import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  FormGroup,
  FormField,
  Dropdown,
  Button
} from 'semantic-ui-react'

const CardVerbalOrderUX = (props: any) => {
    return(
      <div
        id="CardVerbalOrderUX-div-0">
        <div
          id="CardVerbalOrderUX-div-1"
          style={{padding: "10px 0", fontSize: "1.3rem", fontWeight: "bold" ,display: props.onlyDrug ? "none" : "flex", alignItems: "center" }}>
          {props.languageUX === "en" ? "Receive doctor's orders" : "รับคำสั่งแพทย์"}
        </div>
        <div
          className="tabs-verbal-order"
          id="CardVerbalOrderUX-div-2"
          style={{padding: "10px 0", fontSize: "1.2rem", fontWeight: "bold" ,display: props.onlyDrug ? "none" : "flex", alignItems: "center" }}>
          {props.buttonLists}
        </div>
        <div
          id="CardVerbalOrderUX-div-9"
          style={{padding: "10px", display: "flex", alignItems: "center", backgroundColor: "#F3F3F3" }}>
          {props.container}
        </div>
        <div
          className="save-verbal-order"
          style={{padding: "10px", fontSize: "1.2rem", display: props.hiddenPerformed? "none":"flex", alignItems: "center" }}>
          
          <div
            className="ui form"
            id="CardVerbalOrderUX-div-40"
            style={{width: "100%"}}>
            
            <FormGroup
              id="CardVerbalOrderUX-FormGroup-41"
              inline={true}>
              <FormField
                id="CardVerbalOrderUX-FormField-42"
                inline={true}>
                <label
                  id="CardVerbalOrderUX-label-49"
                  style={{ minWidth: "max-content" }}>
                  {props.languageUX === "en" ? "Prescribing physician" : "แพทย์ผู้สั่ง"}
                </label>
              </FormField>
              <FormField
                id="CardVerbalOrderUX-FormField-43"
                inline={true}
                width={5}>
                <div
                  id="CardVerbalOrderUX-div-53"
                  style={{width: "100%"}}>
                  {props.doctorSearchBox}
                </div>
              </FormField>
              <FormField
                id="CardVerbalOrderUX-FormField-44"
                inline={true}
                style={{ display: props.hideMethod ? "none" : "" }}>
                <label
                  id="CardVerbalOrderUX-label-50"
                  style={{ minWidth: "max-content" }}>
                  {props.languageUX === "en" ? "Receive orders" : "รับคำสั่ง"}
                </label>
              </FormField>
              <FormField
                id="CardVerbalOrderUX-FormField-45"
                inline={true}
                style={{ display: props.hideMethod ? "none" : "" }}
                width={5}>
                <Dropdown
                  fluid={true}
                  id="cardverbalorder-dropdown-1"
                  onChange={props.methodOnChange}
                  options={props.methodOptions}
                  selection={true}
                  style={{width: "100%"}}
                  value={props.method}>
                </Dropdown>
              </FormField>
              <FormField
                className="required"
                id="CardVerbalOrderUX-FormField-46"
                inline={true}>
                <label
                  id="CardVerbalOrderUX-label-51"
                  style={{ minWidth: "max-content" }}>
                  {props.languageUX === "en" ? "Confirm recipient code" : "ยืนยันรหัสผู้รับคำสั่ง"}
                </label>
              </FormField>
              <FormField
                id="CardVerbalOrderUX-FormField-47"
                inline={true}
                width={5}>
                <div
                  id="CardVerbalOrderUX-div-54"
                  style={{width: "100%"}}>
                  {props.rePassword}
                </div>
              </FormField>
              <FormField
                id="CardVerbalOrderUX-FormField-48"
                inline={true}
                style={{padding: 0}}>
                <Button
                  color="green"
                  disabled={props.disabledSave}
                  fluid={false}
                  id="CardVerbalOrderUX-Button-55"
                  loading={props.saveloading}
                  name={props.containerName}
                  onClick={props.saveVerbalOrder}>
                  {props.save}
                </Button>
              </FormField>
            </FormGroup>
          </div>
        </div>
      </div>
    )
}


export default CardVerbalOrderUX

export const screenPropsDefault = {}

/* Date Time : Mon Aug 18 2025 09:30:52 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardVerbalOrderUX-div-0"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": "รับคำสั่งแพทย์",
          "valueEN": "Receive doctor's orders"
        },
        "id": {
          "type": "value",
          "value": "CardVerbalOrderUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"10px 0\", fontSize: \"1.3rem\", fontWeight: \"bold\" ,display: props.onlyDrug ? \"none\" : \"flex\", alignItems: \"center\" }"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonLists"
        },
        "className": {
          "type": "value",
          "value": "tabs-verbal-order"
        },
        "id": {
          "type": "value",
          "value": "CardVerbalOrderUX-div-2"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"10px 0\", fontSize: \"1.2rem\", fontWeight: \"bold\" ,display: props.onlyDrug ? \"none\" : \"flex\", alignItems: \"center\" }"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 9,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": "props.container"
        },
        "id": {
          "type": "value",
          "value": "CardVerbalOrderUX-div-9"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"10px\", display: \"flex\", alignItems: \"center\", backgroundColor: \"#F3F3F3\" }"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": null,
      "id": 10,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "save-verbal-order"
        },
        "id": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{padding: \"10px\", fontSize: \"1.2rem\", display: props.hiddenPerformed? \"none\":\"flex\", alignItems: \"center\" }"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": null,
      "id": 40,
      "name": "div",
      "parent": 10,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardVerbalOrderUX-div-40"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 40,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 41,
      "name": "FormGroup",
      "parent": 40,
      "props": {
        "id": {
          "type": "value",
          "value": "CardVerbalOrderUX-FormGroup-41"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 41,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 42,
      "name": "FormField",
      "parent": 41,
      "props": {
        "id": {
          "type": "value",
          "value": "CardVerbalOrderUX-FormField-42"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 42,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 43,
      "name": "FormField",
      "parent": 41,
      "props": {
        "id": {
          "type": "value",
          "value": "CardVerbalOrderUX-FormField-43"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 43,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 44,
      "name": "FormField",
      "parent": 41,
      "props": {
        "id": {
          "type": "value",
          "value": "CardVerbalOrderUX-FormField-44"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.hideMethod ? \"none\" : \"\" }"
        }
      },
      "seq": 44,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 45,
      "name": "FormField",
      "parent": 41,
      "props": {
        "id": {
          "type": "value",
          "value": "CardVerbalOrderUX-FormField-45"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.hideMethod ? \"none\" : \"\" }"
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 45,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 46,
      "name": "FormField",
      "parent": 41,
      "props": {
        "className": {
          "type": "value",
          "value": "required"
        },
        "id": {
          "type": "value",
          "value": "CardVerbalOrderUX-FormField-46"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 46,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 47,
      "name": "FormField",
      "parent": 41,
      "props": {
        "id": {
          "type": "value",
          "value": "CardVerbalOrderUX-FormField-47"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 47,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 48,
      "name": "FormField",
      "parent": 41,
      "props": {
        "id": {
          "type": "value",
          "value": "CardVerbalOrderUX-FormField-48"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{padding: 0}"
        }
      },
      "seq": 48,
      "void": false
    },
    {
      "from": null,
      "id": 49,
      "name": "label",
      "parent": 42,
      "props": {
        "children": {
          "type": "value",
          "value": "แพทย์ผู้สั่ง",
          "valueEN": "Prescribing physician"
        },
        "id": {
          "type": "value",
          "value": "CardVerbalOrderUX-label-49"
        },
        "style": {
          "type": "code",
          "value": "{ minWidth: \"max-content\" }"
        }
      },
      "seq": 49,
      "void": false
    },
    {
      "from": null,
      "id": 50,
      "name": "label",
      "parent": 44,
      "props": {
        "children": {
          "type": "value",
          "value": "รับคำสั่ง",
          "valueEN": "Receive orders"
        },
        "id": {
          "type": "value",
          "value": "CardVerbalOrderUX-label-50"
        },
        "style": {
          "type": "code",
          "value": "{ minWidth: \"max-content\" }"
        }
      },
      "seq": 50,
      "void": false
    },
    {
      "from": null,
      "id": 51,
      "name": "label",
      "parent": 46,
      "props": {
        "children": {
          "type": "value",
          "value": "ยืนยันรหัสผู้รับคำสั่ง",
          "valueEN": "Confirm recipient code"
        },
        "id": {
          "type": "value",
          "value": "CardVerbalOrderUX-label-51"
        },
        "style": {
          "type": "code",
          "value": "{ minWidth: \"max-content\" }"
        }
      },
      "seq": 51,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 52,
      "name": "Dropdown",
      "parent": 45,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "cardverbalorder-dropdown-1"
        },
        "onChange": {
          "type": "code",
          "value": "props.methodOnChange"
        },
        "options": {
          "type": "code",
          "value": "props.methodOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.method"
        }
      },
      "seq": 52,
      "void": false
    },
    {
      "from": null,
      "id": 53,
      "name": "div",
      "parent": 43,
      "props": {
        "children": {
          "type": "code",
          "value": "props.doctorSearchBox"
        },
        "id": {
          "type": "value",
          "value": "CardVerbalOrderUX-div-53"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 53,
      "void": false
    },
    {
      "from": null,
      "id": 54,
      "name": "div",
      "parent": 47,
      "props": {
        "children": {
          "type": "code",
          "value": "props.rePassword"
        },
        "id": {
          "type": "value",
          "value": "CardVerbalOrderUX-div-54"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 54,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 55,
      "name": "Button",
      "parent": 48,
      "props": {
        "children": {
          "type": "code",
          "value": "props.save"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "disabled": {
          "type": "code",
          "value": "props.disabledSave"
        },
        "fluid": {
          "type": "code",
          "value": "false"
        },
        "id": {
          "type": "value",
          "value": "CardVerbalOrderUX-Button-55"
        },
        "loading": {
          "type": "code",
          "value": "props.saveloading"
        },
        "name": {
          "type": "code",
          "value": "props.containerName"
        },
        "onClick": {
          "type": "code",
          "value": "props.saveVerbalOrder"
        }
      },
      "seq": 55,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": false,
  "name": "CardVerbalOrderUX",
  "project": "New Project",
  "screenPropsDefault": {
  },
  "width": 80
}

*********************************************************************************** */
